import styled from "styled-components";

export const StyledSideMenuDivider = styled("li").attrs(() => ({
	role: "separator",
}))`
	margin: 0.35rem 0.5rem;
	background: ${({ theme: { colors } }) => colors.buttonsDefaultGrey};
	height: var(--size-grid-small);
`;
